@if (isEditMode) {
  <mat-form-field appearance="fill" class="edit-form">
    <mat-label>Instance</mat-label>
    <input
      type="text"
      aria-label="Instance"
      matInput
      [formControl]="urlControl"
      [matAutocomplete]="auto"
      (blur)="onAutoCompleteBlur(true, auto)"
      (keyup.enter)="onAutoCompleteBlur()"
    />
    @if (shouldShowClearAutoComplete) {
      <button matSuffix mat-icon-button (click)="onClearAutoComplete()">
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (loadingConfig()) {
      <mat-spinner
        matSuffix
        [diameter]="18"
        style="float: right; margin-left: 8px; margin-top: 6px"
      ></mat-spinner>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onAutoCompleteSelected($event)"
    >
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-autocomplete>
    @if (urlControl.invalid) {
      <mat-error>{{ inputError }}</mat-error>
    }
  </mat-form-field>
} @else {
  <div class="static-text-area">
    @if (parseHost(url); as parsedHost) {
      <mat-icon
        class="dim text-icon"
        matTooltip="{{ url }}"
        matTooltipShowDelay="1000"
        matTooltipPosition="right"
        >{{ parsedHost.isCloud ? 'cloud' : 'dns' }}</mat-icon
      >
      <div class="dim static-url-text">
        {{ parsedHost.host }}
      </div>
    } @else {
      <mat-icon
        class="dim mat-error text-icon"
        matTooltip="{{ url }}"
        matTooltipShowDelay="1000"
        matTooltipPosition="right"
        >cloud_off</mat-icon
      >
      <div class="mat-error dim static-url-text">
        {{ 'UNKNOWN_HOST' | transloco }}
      </div>
    }
    <span class="spacer"></span>
    <button
      id="url-edit-button"
      matIconButton
      (click)="isEditMode = true"
      matTooltip="{{ 'EDIT_INSTANCE' | transloco }}"
      matTooltipShowDelay="1000"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </div>
}

@if (loadingConfig()) {
  <!-- Indeterminate while connecting, as the instance response time is unknown. -->
  <mat-progress-bar
    id="config-loading-bar"
    mode="indeterminate"
    aria-label="Connecting to instance"
  ></mat-progress-bar>
}

@if (
  !isValid &&
  isEditMode &&
  !configLoadFailed() &&
  !loadingConfig()
) {
  <button
    mat-raised-button
    id="continue-button"
    color="primary"
    [disabled]="urlControl.invalid"
    (click)="onContinueClick()"
  >
    {{ 'CONTINUE' | transloco }}
  </button>
}

@if (configLoadFailed() && !loadingConfig()) {
  <button
    matButton="filled"
    id="retry-button"
    type="button"
    (click)="onRetryClick()"
  >
    <mat-icon>refresh</mat-icon>
    Retry
  </button>
}
